import Bank from "./Bank";

const BankConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/bank',
            element: <Bank/>,
        },

    ],
};

export default BankConfig;
